module.exports = __webpack_public_path__ + "img/152.a8be8c60.jpg";